import { Component, Input, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { CREDIT_CATEGORY_RECORD } from '../../../../helpers/CreditCategory';
import { ApiLavandierService } from '../../../../../lib/lib-ngx/web-services/api-lavandier.service';
import { CreditType } from '../../../../../lib/lib-shared/types/CreditType';
import { CreditCategory } from '../../../../../lib/lib-shared/types/CreditCategory';
import { PRICEMULTIPLIER } from '../../../../../lib/lib-shared/defines';
import { IUserCreditEditFormSubmit } from './user-credit-edit-form/user-credit-edit-form.component.type';
import { ICreditDetailsListByUserId } from '../../../../../lib/lib-shared/models/Credit';
import { ConfirmationModalComponent } from '../../../modals/confirmation-modal/confirmation-modal.component';
import { ErrorService } from '../../../../../lib/lib-ngx/services/error.service';
import { IsCreditCancelledPipe } from './is-credit-cancelled.pipe';

@Component({
  selector: 'lm-user-credit',
  templateUrl: './user-credit.component.html',
  styleUrls: ['./user-credit.component.scss']
})
export class UserCreditComponent implements OnInit {
  public PRICEMULTIPLIER = PRICEMULTIPLIER;
  public CreditType = CreditType;
  public CreditCategory = CreditCategory;
  public CREDIT_CATEGORY_RECORD = CREDIT_CATEGORY_RECORD;

  @ViewChild('toChargeTable') toChargeTable: any;
  @ViewChild('chargedTable') chargedTable: any;
  @Input() user = null;
  @Input() lavandierMap = new Map();
  public creditToChargeList = [];
  public creditChargedList = [];

  public editingCredit: ICreditDetailsListByUserId | null = null;

  constructor(
    private apiLavandierService: ApiLavandierService,
    private modalService: NgbModal,
    private errorService: ErrorService,
    private isCreditCancelledPipe: IsCreditCancelledPipe,
  ) {
  }

  ngOnInit() {
    this.loadCreditUserList();
  }

  loadCreditUserList() {
    this.creditToChargeList = [];
    this.creditChargedList = [];
    this.apiLavandierService.getCreditUser(this.user.id)
      .subscribe(
        (creditList: any[]) => {
          const creditParentList = [];
          const creditParentIdMap = new Map();
          creditList.forEach((credit) => {
            if (credit.parentId === null) {
              credit.amountLeft = credit.amount;
              credit.childrenList = [];
              creditParentList.push(credit);
            } else {
              creditParentIdMap.set(credit.parentId, credit);
            }
          });

          creditParentList.forEach((credit) => {
            if (credit.type === CreditType.MINUS) {
              if (credit.orderCredit !== null) {
                credit.amountLeft -= credit.orderCredit.amount;
              }
              if (creditParentIdMap.has(credit.id)) {
                credit.amountLeft -= this.calcAmountLeft(creditParentIdMap.get(credit.id), credit.childrenList, creditParentIdMap);
              }
            }
            if (credit.type === CreditType.PERCENT) {
              if (credit.orderCredit !== null) {
                credit.amountLeft = 0;
              }
            }
            if (
              credit.amountLeft > 0 &&
              (!credit.endedAt || moment().isSameOrBefore(moment(credit.endedAt), 'day')) &&
              !this.isCreditCancelledPipe.transform(credit)
            ) {
              this.creditToChargeList.push(credit);
            } else {
              this.creditChargedList.push(credit);
            }
          });
          // Load ngx-datatable
          this.creditToChargeList = [...this.creditToChargeList]; // Refresh data issue
          this.creditChargedList = [...this.creditChargedList];
          this.expandRows(this.toChargeTable);
          this.expandRows(this.chargedTable);
        }
      );
  }

  calcAmountLeft(credit, childrenList, creditParentIdMap) {
    childrenList.push(credit);
    if (!creditParentIdMap.has(credit.id)) {
      return credit.orderCredit !== null ? credit.orderCredit.amount : 0;
    }
    return this.calcAmountLeft(creditParentIdMap.get(credit.id), childrenList, creditParentIdMap) + credit.orderCredit.amount;
  }

  expandRows(table) {
    setTimeout(() => table.rowDetail.expandAllRows());
  }

  cancelCredit(credit: ICreditDetailsListByUserId) {
    const confirmationModal = this.modalService.open(ConfirmationModalComponent, {size: 'lg'});
    confirmationModal.componentInstance.confirmationDesc = 'Voulez-vous vraiment annuler cet avoir ?';
    confirmationModal.componentInstance.validateButtonText = 'Confirmer';
    confirmationModal.componentInstance.cancelButtonText = 'Annuler';
    confirmationModal.result
      .then(result => {
        if (result) {
          this.apiLavandierService
            .deleteCredit(credit.id, {})
            .subscribe(data => {
              if (!this.errorService.manageError(data)) {
                this.loadCreditUserList();
              }
            });
        }
      })
      .catch(() => null);
  }

  openEditCredit(credit: ICreditDetailsListByUserId) {
    this.editingCredit = credit;
  }

  onSubmitEditCredit(params: IUserCreditEditFormSubmit) {
    this.apiLavandierService
      .putCredit(params.id, {amount: params.amount, endedAt: params.endedAt})
      .subscribe(data => {
        if (!this.errorService.manageError(data)) {
          this.editingCredit = null;
          this.loadCreditUserList();
        }
      });
  }

  onCancelEditCredit() {
    this.editingCredit = null;
  }
}
